<template>
    <div class="item-container" v-if="!item.isDeleted" v-bind:style="{
        backgroundColor: item.isHovered ? ' #007bff' : '#77a7fd',
    }" @mouseleave="mouseleave">
        <!-- color: item.hasFigures ? 'white' : '#A9A9A9', -->
        <!-- flexDirection: item.isTooth ? 'column' : 'row' -->

        <div class="item-header" @mouseover="mouseOver">
            <img class="item-btn item-visible" v-on:click="visibilityClick()" title="Visibility"
                :src="item.isVisible ? 'images/visible_on_white.png' : 'images/visible_off_white.png'" />
            <span class="item-color" ref="itemColor" :style="{ backgroundColor: item.color }"
                v-on:click="changeColorClick()" title="Color"></span>
            <div class="an-name" :title="item.displayName">{{ item.wasChanged ? "* " : "" }}{{ item.displayName }}
            </div>

            <img v-if="item.isFace && item.isLoaded && item.hasTexture" class="item-btn item-face-texture"
                v-on:click="faceTextureClick()" title="Texture"
                :src="item.isTextured ? 'images/face-red.png' : 'images/face-white.png'" />

            <img v-if="!item.isTooth && !item.isAirway" class="item-btn item-opacity" v-on:click="opacityClick()"
                title="Opacity" :src="item.isOpacityVisible ? 'images/opacity_grey.png' : 'images/opacity_icon.png'" />
            <img v-if="item.isAirway" class="item-btn item-smooth" v-on:click="smoothToggleClick()" title="Smooth"
                :src="item.isSmoothed ? 'images/smooth_red.png' : 'images/smooth_white.png'" />
        </div>

        <div class="item-opacity-ctrl" v-show="!item.isTooth && !item.isAirway && item.isOpacityVisible"
            @mouseover="mouseleave">
            <input type="range" class="form-range item-opacity-range" min="0" max="1" step="0.01"
                @input="applyOpacityChange()" v-model="item.opacity">
        </div>

        <div class="item-tools" v-if="item.isFace && item.isLoaded && (item.hasSmooth || item.hasWrap)">
            <img v-if="item.isFace && item.hasSmooth" class="item-btn" v-on:click="faceGeometryClick('smooth')"
                :src="item.geomType == 'smooth' ? 'images/half_circle_red.png' : 'images/half_circle_white.png'" />

            <img v-if="item.isFace && item.hasWrap" class="item-btn item-face-wrap"
                v-on:click="faceGeometryClick('wrap')"
                :src="item.geomType == 'wrap' ? 'images/half_wrap_red.png' : 'images/half_wrap_white.png'" />

            <img v-if="item.isFace" class="item-btn" v-on:click="faceGeometryClick('base')"
                :src="item.geomType == 'base' ? 'images/circle1_red.png' : 'images/circle1_white.png'" />

        </div>

        <div class="item-tools" v-if="item.isTooth" @mouseover="mouseOver">
            <img v-if="item.isTooth" class="item-btn item-settings" v-on:click="editSettingsClick()" title="Settings"
                :src="'images/gear_white_icon.png'" />
            <img v-if="item.isTooth" class="item-btn item-focus" v-on:click="focusClick()" title="Focus"
                :src="item.isFocused ? 'images/focus_red.png' : 'images/focus_white.png'" />
            <img v-if="item.isTooth" class="item-btn" v-on:click="removeClick()" title="Delete"
                :src="'images/trash_icon.png'" />

        </div>

    </div>
</template>

<script>
import swal from "sweetalert";
import {
    highlightItem, unhighlightItem, focusItem, switchFaceVisibility, switchFaceGeometry,
    unfocusItem, deleteItem, editItemSettings, smoothToggle, switchFaceMaterial
} from "./TeethListManager";

export default {
    name: "TeethListItem",
    props: {
        item: {
            type: Object,
            required: true
        },
    },
    data() {
        return {
            isMouseOver: false
        };
    },
    watch: {
        "item.isHovered": {
            handler(newVal, oldVal) {
                if (newVal) {
                    highlightItem(this.item);
                }
                else {
                    unhighlightItem(this.item);
                }
            }
        },
        "item.isClicked": {
            handler(newVal, oldVal) {
                if (newVal) {
                    if (!this.isMouseOver) {
                        this.$el.scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest" });
                    }
                    this.item.isClicked = false;
                }
            }
        },
    },
    methods: {
        faceGeometryClick: function (geomType) {
            this.item.geomType = geomType;
            switchFaceGeometry(geomType);
        },
        faceTextureClick: function () {
            this.item.isTextured = !this.item.isTextured;
            switchFaceMaterial();
        },
        mouseOver: function () {
            this.isMouseOver = true;
            this.item.isHovered = true;
        },
        mouseleave: function () {
            this.isMouseOver = false;
            this.item.isHovered = false;
        },
        editSettingsClick: function () {
            if (vueApp.isViewMode) {
                swal({
                    text: "Cannot edit tooth settings in the view mode.",
                });
                return;
            }
            if (vueApp.isStitching) {
                swal({
                    text: "Cannot edit tooth settings while post processing.",
                });
                return;
            }
            editItemSettings(this.item);
        },
        focusClick: function () {
            if (!this.item.isTooth)
                return;
            this.item.isFocused = !this.item.isFocused;
            if (this.item.isFocused) {
                focusItem(this.item);
            } else {
                unfocusItem(this.item);
            }
        },
        visibilityClick: function () {
            this.item.isVisible = !this.item.isVisible;
            if (this.item.isVisible)
                this.item.isHidden = false;
            if (this.item.isFace) {
                switchFaceVisibility(this.item);
            }
            else {
                itemVisibilityChanged(this.item, this.item.color, this.item.teethOpacity);
                // console.log('isVisibleChanged', this.item);
                vueApp.$emit('visibilityChanged', this.item);
            }

        },
        removeClick: function () {
            deleteItem(this.item);
        },
        changeColorClick: function () {
            console.log("changeColor", this.item.filename);
            if (!vueApp.airways || !vueApp.airways.length || !vueApp.airways.includes(this.item))
                openColorPicker(this.item.isFace ? "face" : this.item.id);
            // setTimeout(() => {
            // 	openColorPicker(this.item.id);
            // }, 100);
        },
        opacityClick: function () {
            this.item.isOpacityVisible = !this.item.isOpacityVisible;
            // this.item.isHovered = false;
        },
        smoothToggleClick: function () {
            smoothToggle(this.item, !this.item.isSmoothed);
        },
        applyOpacityChange: function () {
            if (this.item.isFace) {
                this.item.getMesh().material.opacity = this.item.opacity;
            } else {
                viewer.set_opacity(this.item.id, this.item.opacity);
            }
        }
    }
}

</script>

<style scoped>
/*********** Baseline, reset styles ***********/
input[type="range"] {
    -webkit-appearance: none;
    appearance: none;
    background: transparent;
    cursor: pointer;
}

/* Removes default focus */
input[type="range"]:focus {
    outline: none;
}

/******** Chrome, Safari, Opera and Edge Chromium styles ********/
/* slider track */
input[type="range"]::-webkit-slider-runnable-track {
    background-color: #ffffff;
    border-radius: 0.5rem;
    border-color: black;
    height: 0.5rem;
}

/* slider thumb */
input[type="range"]::-webkit-slider-thumb {
    -webkit-appearance: none;
    /* Override default look */
    appearance: none;
    margin-top: -4px;
    /* Centers thumb on the track */
    background-color: #ffffff;
    border-radius: 0.5rem;
    border-color: black;
    height: 1rem;
    width: 1rem;
}

input[type="range"]::-webkit-slider-thumb {
    outline: 1px solid #9e9e9e;
}

/*********** Firefox styles ***********/
/* slider track */
input[type="range"]::-moz-range-track {
    background-color: #ffffff;
    border-radius: 0.5rem;
    height: 0.5rem;
}

/* slider thumb */
input[type="range"]::-moz-range-thumb {
    background-color: #ffffff;
    border: none;
    /*Removes extra border that FF applies*/
    border-radius: 0.5rem;
    height: 1rem;
    width: 1rem;
}

input[type="range"]::-moz-range-thumb {
    outline: 1px solid #9e9e9e;
    /* outline-offset: 0.125rem; */
}
</style>

<style scoped>
/* @import "../../css/slider.css"; */



.item-opacity-ctrl {
    text-align: center;
}

.item-opacity-range {
    margin-top: 5px;
    width: 100%;
    /* accent-color: white; */
    /* -webkit-appearance: none; */
}

.item-container {
    color: white;
    padding: 0.2rem;
    border: solid white 0.1rem;
    display: flex;
    gap: 3px;
    flex-direction: column;
}

.item-header {
    display: flex;
    align-items: stretch;
    gap: 4px;
    width: 100%;
}

.item-tools {
    display: flex;
    align-items: stretch;
    gap: 13px;
    margin-left: 3px;
}

.item-selected {
    display: block;
}

.item-color {
    margin-top: 2px;
    margin-left: 8px;
    height: 20px;
    width: 20px;
    min-height: 20px;
    min-width: 20px;
    background-color: #bbb;
    border-radius: 50%;
    display: inline-block;
    cursor: pointer;
}

.an-name {
    margin-top: 1px;
    white-space: nowrap;
    /* text-wrap: nowrap; */
    overflow: hidden;
    text-overflow: ellipsis;
    text-align: left;
    flex-grow: 1;
    max-width: calc(100% - 68px);
}

.item-btn {
    margin-top: 1px;
    height: 20px;
    width: 20px;
    cursor: pointer;
}

.item-visible {
    margin-top: 0px;
    height: 25px;
    width: 25px;
}

.item-focus {
    margin-top: 0px;
    height: 23px;
    width: 23px;
}

.item-face-texture {
    margin-top: 2px;
    margin-right: 1px;
}

.item-face-geometry {
    margin-top: 2px;
    /* margin-right: -3px; */
}

.item-face-wrap {
    margin-left: -5px;
}

.item-smooth {
    margin-right: 2px;
}

.item-opacity {
    cursor: pointer;
    margin-top: 0px;
    height: 24px;
    width: 24px;
}

.item-settings {
    margin-top: 2px;
}
</style>